import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import { CountryBuilder } from '../country.types';

export const getAllCountries = (builder: CountryBuilder) =>
  builder.query<any, void>({
    query: () => ({
      url: `/countries`,
      method: 'GET',
    }),
    transformResponse: (response: any) => {
      return response;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[getAllCountries]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.CountryError
          : ErrorMessageEn.CountryError,
        error,
        true
      );
      return error.data;
    },
  });
